import React from "react";

const RuIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="19"
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0H24V19H0V0Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 6.33333H24V19H0V6.33333Z"
          fill="#0039A6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 12.6667H24V19H0V12.6667Z"
          fill="#D52B1E"
        />
      </svg>
    </>
  );
};

export default RuIcon;
